import { Component, Input } from '@angular/core';
import { DataSharingService } from '../../../services/data-sharing.service';
import { CompanyService } from '../../../services/company.service';
import { pluralMappings } from '../../../classes/i18n';
import { MessageService } from '../../../services/message.service';
declare var $: any;

@Component({
  selector: 'magic-bulk-unlock',
  templateUrl: './magic-bulk-unlock.component.html',
  styleUrl: './magic-bulk-unlock.component.css',
})
export class MagicBulkUnlockComponent {
  @Input() modulesInfo: Record<string, any>[];
  companyIds: number[] = [];
  selectedMagicModuleIds: number[] = [];
  selectedModuleId: number = null;
  totalCreditsCost: number = null;
  pluralMappings = pluralMappings;

  constructor(
    private dataStore: DataSharingService,
    private companyService: CompanyService,
    private messageService: MessageService
  ) {}

  loadingState = this.companyService.isLoading;

  ngOnInit() {
    // TODO: checkboxes instead
    // this.modulesInfo = this.modulesInfo.map(module => ({
    //   ...module,
    //   // checked: this.modulesInfo.length === 1 || false,
    // }));
    this.selectedModuleId =
      this.modulesInfo.length === 1 ? this.modulesInfo[0].id : null;
    this.dataStore.currentSelectedCompanyIds.subscribe(data => {
      this.companyIds = data;
    });
    this.handleSelectedModuleIdsChange();
  }

  handleSelectedModuleIdsChange() {
    //TODO: checkboxes
    // this.selectedMagicModuleIds = this.modulesInfo
    //   .filter(module => module.checked)
    //   .map(item => item.id);
    this.selectedMagicModuleIds = this.selectedModuleId
      ? [this.selectedModuleId]
      : null;
    this.totalCreditsCost = this.companyIds.length;
  }

  confirmUnlockMIForSelectedCompanies(): void {
    this.companyService
      .unlockMagicInsightsModules(
        this.selectedMagicModuleIds[0],
        this.companyIds
      )
      .subscribe(response => {
        if (response.ok === true) {
          this.messageService.showInfo(
            'Magic Insights have been unlocked for the selected companies.',
            4000
          );
        }
      });

    $('#magicInsightsBulkUnlock').modal('hide');
  }
}
